import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import { type QueryState, reshapeQueryState } from 'src/core/api/queryState';
import { mapQueryResultToQueryState } from 'src/core/api/utils/queryState';
import { useBudgetDimensionData } from 'src/core/modules/budgets/budgets-by-dimensions/hooks/useBudgetDimensionData';
import {
  type BreakdownsResponse,
  useGetBudgetBreakdowns,
} from 'src/core/modules/budgets/budgets-by-dimensions/hooks/useGetBudgetBreakdowns';
import { type DimensionData } from 'src/core/modules/budgets/budgets-by-dimensions/models/dimensionData';
import { type PeriodInterval } from 'src/core/modules/budgets/models/periodInterval';

export type BreakdownsWithEditData = {
  breakdownsResponse: BreakdownsResponse;
  dimensionData: DimensionData;
};

export const useBreakdownsWithDimensionData = (
  budgetId: string,
  period: PeriodInterval,
): QueryState<BreakdownsWithEditData> => {
  const breakdownsQueryState = mapQueryResultToQueryState(
    useGetBudgetBreakdowns(budgetId, period),
  );
  const dimensionDataQueryState = useBudgetDimensionData(
    reshapeQueryState(breakdownsQueryState, ({ breakdowns }) => breakdowns),
  );
  return useQueryStates({
    states: {
      breakdownsResponse: breakdownsQueryState,
      dimensionData: dimensionDataQueryState,
    },
  });
};
